module.exports = __webpack_public_path__ + "static/media/vfl-shareMyCar-phone.f9bb7ecc.png";